import React, { useState } from "react";
import axios from "../common/axios";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import { Label } from "src/components/ui/label";

export default function ResetPW() {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  // const history = useHistory();
  const navigate = useNavigate(); // useNavigate 사용

  function isValidEmail(email) {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(email);
  }

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setIsValid(isValidEmail(emailValue));
  };

  const sendEmail = async (e) => {
    try {
      const response = await axios.post(`/loa_resetpw`, { email });
      if (response.data.success) {
        Swal.fire({
          title: "성공!",
          text: "비밀번호 재설정 이메일이 발송되었습니다.",
          icon: "success",
          confirmButtonText: "확인",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          }
        });
      } else {
        Swal.fire({
          title: "오류",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "확인",
        });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || "Error during login";
      Swal.fire({
        title: "오류",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "확인",
      });
    }
  };

  return (
    <>
      <div className="flex min-h-screen flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-[336px]">
          <div className="text-center mb-7">
            <div className="flex items-center justify-center mb-4">
              <a href="http://www.samsungshi.com/kor/default.aspx">
                <img alt="Logo" src="/images/g1313.png" className="h-8 w-auto" />
              </a>
            </div>
            <h1 className="text-foreground font-extrabold text-[19px] tracking-tight mb-2">
              삼성중공업 현장공무 LOA 결재 시스템
            </h1>
            <p className="text-muted-foreground text-sm">
              비밀번호 재설정을 위한 이메일을 입력하세요.
            </p>
          </div>

          <div className="rounded-lg border bg-card p-6">
            <h2 className="text-foreground font-bold text-base mb-1">
              비밀번호 재설정
            </h2>
            <p className="text-muted-foreground text-xs mb-5">
              가입 시 등록한 이메일을 입력하세요.
            </p>

            <form noValidate>
              <div className="mb-4">
                <Label htmlFor="email" className="mb-1.5 block">
                  이메일
                </Label>
                <Input
                  id="email"
                  type="text"
                  placeholder="이메일"
                  name="email"
                  autoComplete="off"
                  onChange={handleEmailChange}
                />
              </div>
              <div className="flex flex-wrap justify-center gap-3">
                <Button
                  type="button"
                  disabled={!isValid}
                  onClick={sendEmail}
                  className="flex-1"
                >
                  이메일 보내기
                </Button>
                <Button asChild variant="outline" className="flex-1">
                  <RouterLink to={{ pathname: "/login" }}>취소</RouterLink>
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
